export default {
  allowCancel: true,
  debug: false,
  skipDomainVerification: false,
  testMode: false,
  timeout: 30000, // 30 seconds
  allowViewportOverride: false,
};
